import script from "./PowerupAuth.vue?vue&type=script&lang=js"
export * from "./PowerupAuth.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f1cd8eb"]])

export default __exports__